const DIACRITICS = /[\u0300-\u036f]/g

/**
 * Minúsculas y sin tildes, conservando la misma longitud que el texto original
 * (un carácter por carácter) para poder resaltar coincidencias en el texto real.
 */
export function normalize(text: string): string {
  let out = ''
  for (let i = 0; i < text.length; i++) {
    const n = text[i].normalize('NFD').replace(DIACRITICS, '').toLowerCase()
    out += n.length ? n[0] : ' '
  }
  return out
}

export function slugify(text: string): string {
  return normalize(text)
    .replace(/[’']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

export function levenshtein(a: string, b: string, max: number): number {
  if (Math.abs(a.length - b.length) > max) return max + 1
  let prev = Array.from({ length: b.length + 1 }, (_, i) => i)
  for (let i = 1; i <= a.length; i++) {
    const curr = [i]
    let rowMin = i
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost)
      rowMin = Math.min(rowMin, curr[j])
    }
    if (rowMin > max) return max + 1
    prev = curr
  }
  return prev[b.length]
}

export function joinList(items: string[]): string {
  if (items.length <= 1) return items.join('')
  return `${items.slice(0, -1).join(', ')} y ${items[items.length - 1]}`
}
